























import { Component, Prop, Vue } from 'vue-property-decorator';
import MainButton from '@/main-components/common/MainButton.vue';
import Modal from '@/main-components/common/modal/Modal.vue';

@Component({
  components: {
    MainButton,
    Modal,
  },
})
export default class ModalGoogleForm extends Vue {
  @Prop({ default: 'Title' })
  title: string;

  @Prop({ default: 'Description' })
  description: string;

  @Prop({ required: true })
  formSrc: string;

  @Prop({ required: true })
  height: string;

  isLoading = false;
  openModalGoogleForm: any = null;
  closeModalGoogleForm: any = null;

  mounted() {
    this.$emit('openModalGoogleFormAdd', this.openModalGoogleForm);
  }

  closeModal() {
    this.closeModalGoogleForm && this.closeModalGoogleForm();
  }

  openModalAdd(openModal: any) {
    this.openModalGoogleForm = openModal;
  }

  closeModalAdd(closeModal: any) {
    this.closeModalGoogleForm = closeModal;
  }
}
